export default {"src":"/_next/static/media/User Password.069a2080.svg","height":140,"width":140,"blurWidth":0,"blurHeight":0};